module.exports = __webpack_public_path__ + "img/AddToHomeScreenOutlined.7142ecf9.svg";